// extracted by mini-css-extract-plugin
export var drawerPaper = "_2f-0";
export var itemCard = "_2f-1";
export var itemImage = "_2f-2";